import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'

export default class Modalcheckpayment extends Component {
    constructor(props) {
        super(props);
                this.state = {
                modal: false,

               // send_id :'1', //ผู้ลงทะเบียน
                send_type : '', //ประเภท
                namepresent : '', //ผู้นำเสนอ
                send_name : '', //ชื่อบทความ
                major_precent : '', //สาขาที่นำเสนอ
                send_uploadeword1 : null,
                send_uploadepdf1 : null,
                send_uploadeword12 : null,
                send_uploadepdf12 : null,
                send_date1 : '', //  วันที่ส่ง
                send_status : '', //สถานะ ชำระเงิน
                stapat : '0',   //สถานะส่ง

                iduser:'',

                
                id_send:'',
                send_id:'',
                date_showslip:'', //วันที่ชำระ
                date_showinvote:'',//วันที่โชว์ในใบเสร็จ
                send_money:'', //จำนวนเงิน
                send_song:'', //ประเภทการโอน
                send_fileslip: null,
                pic:'',

                Payment:[],

                }

              
                this.handleSubmit = this.handleSubmit.bind(this);


              
                this.toggle = this.toggle.bind(this);
             
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.props.selectatf();
}


 componentDidMount() {
    //    const { id_send } = this.props.id_send
    //     const { send_id } = this.props.send_id
    //   // console.log(id_send);
    //     this.setState({ id_send:this.props.id_send})
    //     this.setState({ send_id:this.props.send_id})
      setTimeout(() => {
        //ภายใน
         Axios.get('https://conference.kpru.ac.th/PHPAPI/selectcheckpayment.php?id='+this.props.id_send)
        .then(res => {
          console.log(res);
        //  this.setState({ bankname: res.data, loading: false })
          this.setState({ Payment: res.data,
                      date_showslip:res.data[0].date_showslip,
                      date_showinvote:res.data[0].date_showinvote,
                      send_money:res.data[0].send_money,
                      send_song:res.data[0].send_song,
                      pic:res.data[0].send_fileslip,
        })

        }) 

      }, 0);

  }

//   getExpert() {
//     setTimeout(() => {
//       //ภายใน
//        Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
//       .then(res => {
//         console.log(res);
//       //  this.setState({ bankname: res.data, loading: false })
//         this.setState({ Expert: res.data})
//       }) 
//     }, 0);

// }





  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_send", this.props.id_send);
     

  Axios.post("https://conference.kpru.ac.th/PHPAPI/updatecheckpayment.php",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
   console.log(res.data.status)
    if (res.data.status = 'success888') {
   
     Swal.fire({
      title: 'บันทึกตรวจหลักฐานสำเร็จ',
      text: "Record of successful verification of evidence",
      icon: 'success',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ตกลง'
    }).then((result) => {
      if (result.isConfirmed) {
          this.props.updateat()
          this.toggle()
      }
    })
    
    }else{
          message.error("อัพโหลไฟล์ไม่สำเร็จ!")
    }

  })



}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()

  }

  

    render() {
        
          console.log(this.state.date_showslip)
          console.log(this.state.date_showinvote)
          console.log(this.state.send_money)
          console.log(this.state.send_song)
          console.log(this.state.send_fileslip)


        return (
            <>
            <MDBBtn color="unique" onClick={this.toggle} size="sm"><MDBIcon icon="file-invoice-dollar" /> ตรวจหลักฐานชำระเงิน</MDBBtn>

            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader toggle={this.toggle}>แนบหลักฐานชำระเงิน</MDBModalHeader>
              <MDBModalBody>
              <div>
            
                         <div className='text-center'>   <img src={`https://conference.kpru.ac.th/PHPAPI/slip/${this.state.pic}`} className="img-fluid z-depth-5 " alt=""  />  <br/><br/>
                          <h4>วันที่โอน : {this.state.date_showslip}</h4>
                          <h4>จำนวนเงิน : {this.state.send_money}</h4>
                          <h4>ประเภทการโอน : {this.state.send_song}</h4>
                          <h4>วันที่โชว์ในใบเสร็จ : {this.state.date_showinvote}</h4>
                          <MDBBtn color="dark-green" onClick={this.handleSubmit}>ผ่าน</MDBBtn>
                          </div>
              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                {/* <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> */}
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}
